export function convertDateToGerman(date, options = { weekday: 'long' }) {
    if (date !== undefined) {
        return new Date(date).toLocaleString('de-de', options);
    }
}

export function formatDateDDMMYYYY(date) {
    if (date !== undefined) {
        return new Date(date).toLocaleString('de-de', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
}

export function convertDate(date) {
    let tmp = date.split('.');
    return tmp[2] + '-' + tmp[1] + '-' + tmp[0];
}

export function convertPrice(
    price,
    // Do not display decimal places for round prices
    minimumFractionDigits = Number(price) % 1 === 0 ? 0 : 2,
    maximumFractionDigits = 2
) {
    if (price || price === 0) {
        return price.toLocaleString('de-DE', {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
            style: 'currency',
            currency: 'EUR',
        });
    }
}

export function calculateAge(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);

    return Math.abs(age_dt.getUTCFullYear() - 1970);
}

export function createPaxAges(pax) {
    let tmp = pax.split(';');
    let result = [];
    for (var i = 0; i < tmp.length; i++) {
        let tmp2 = tmp[i];
        let tmp3 = tmp2.split(':');
        result.push({ pax: tmp3[0], age: tmp3[1] });
    }
    return result;
}

export function replaceSpecialChars(str) {
    const umlautMap = {
        '\u00dc': 'UE',
        '\u00c4': 'AE',
        '\u00d6': 'OE',
        '\u00fc': 'ue',
        '\u00e4': 'ae',
        '\u00f6': 'oe',
        '\u00df': 'ss',
    };

    return str
        .replaceAll('&', '')
        .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
            const big = umlautMap[a.slice(0, 1)];
            return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
        })
        .replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', 'g'), (a) => umlautMap[a])
        .replace(/-+/g, '-');
}

export function listenCookieChange(callback, interval = 1000) {
    let lastCookie = document.cookie;

    setInterval(() => {
        let cookie = document.cookie;
        if (cookie !== lastCookie) {
            try {
                callback();
            } finally {
                lastCookie = cookie;
            }
        }
    }, interval);
}

export function setupCookie(cname, cvalue, exdays) {
    let cookie = `${cname}=${cvalue};`;

    let expires = '';
    if (exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        expires = `expires=${d.toUTCString()};`;
    }

    let path = `path=/;`;

    let domain = window.location.hostname.split('.').slice(-2);
    domain = `domain=${domain[0]}${!domain[1] ? '' : '.' + domain[1]}`;

    // set
    document.cookie = `${cookie}${expires}${path}${domain};secure;SameSite=Strict`;
}

export function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export function deleteCookie(cname) {
    let domain = window.location.hostname.split('.').slice(-2);
    domain = `domain=${domain[0]}${!domain[1] ? '' : '.' + domain[1]}`;

    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domain}`;
}
